import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { formatCurrency, formatDateNumeric } from "@/lib/format-amount";
import { TeamUnpaidInvoiceDTO } from "@shaarp/common";
import { ReceiptIcon } from "lucide-react";
import { ReactNode } from "react";

/**
 * Tells Shaarp staff that a team has an invoice to pay by transfer, and whether
 * it is already blocked by it (#742).
 */
export const DataTableCellAdminsUnpaidInvoice = ({
  invoice,
}: {
  readonly invoice: TeamUnpaidInvoiceDTO;
}): ReactNode => {
  const { t, i18n } = useTranslation();
  const prefix = "admin.dataTableAdminTeams.unpaidInvoice";
  const values = {
    amount: formatCurrency(invoice.amountDue, invoice.currency, i18n.language),
    date: formatDateNumeric(invoice.dueAt, i18n.language),
  };

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Badge variant={invoice.blocked ? "destructive" : "warning"}>
          <ReceiptIcon className="w-3 h-3" />
          {t(invoice.blocked ? `${prefix}.blocked` : `${prefix}.pending`)}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        {t(
          invoice.blocked ? `${prefix}.blockedTooltip` : `${prefix}.pendingTooltip`,
          values
        )}
      </TooltipContent>
    </Tooltip>
  );
};
